var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { action, makeObservable } from 'mobx';
import { observer } from 'mobx-react';
let CycleDot_ = class CycleDot_ extends React.PureComponent {
    constructor(props) {
        super(props);
        makeObservable(this);
    }
    get backgroundColor() {
        const { answer } = this.props;
        const { answerInfo } = answer;
        const lightGrey = 'rgba(0,0,0,0.15)';
        const yellow = '#ed9a00';
        const green = '#7ca71f';
        const red = '#b91111';
        if (answerInfo.isAnswerNotYetPosed) {
            return lightGrey;
        }
        if (answerInfo.isAnswerNotYetCompleted) {
            return 'rgba(0,0,0,0.5)';
        }
        if (answerInfo.hasAnswerFullPoints) {
            return green;
        }
        if (answerInfo.hasAnswerZeroPoints) {
            return red;
        }
        return yellow;
    }
    get boxShadow() {
        if (this.props.answer.answerInfo.isCurrentAnswer) {
            return '0px 0px 2px 2px rgba(0,0,0,0.7)';
        }
        return undefined;
    }
    get cursor() {
        if (this.props.answer.answerInfo.isHistoricAnswer || this.props.answer.answerInfo.isFrontalAnswer) {
            return 'pointer';
        }
        return undefined;
    }
    render() {
        const { answer } = this.props;
        if (!answer)
            return null;
        return (React.createElement("div", { style: {
                cursor: this.cursor,
                backgroundColor: this.backgroundColor,
                boxShadow: this.boxShadow,
                flex: '1 1 auto',
                padding: '2px 0px 2px 0px',
                borderRadius: 2,
                margin: 1,
                height: 13,
            }, onMouseEnter: this.preloadAnswer, onClick: this.handleDotClick }));
    }
    handleDotClick(e) {
        const { answer } = this.props;
        e.preventDefault();
        if (answer.answerInfo.isHistoricAnswer || answer.answerInfo.isFrontalAnswer) {
            answer.stageMe();
        }
        return false;
    }
    preloadAnswer() {
        const preload = this.props.answer.answerPrepare.isPrepared;
    }
};
__decorate([
    action.bound
], CycleDot_.prototype, "handleDotClick", null);
__decorate([
    action.bound
], CycleDot_.prototype, "preloadAnswer", null);
CycleDot_ = __decorate([
    observer
], CycleDot_);
export { CycleDot_ };
